import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { CallingCodeState } from "./calling-code.model";

export const ACTION_PREFIX = "[Calling Code]";
export const CALLING_CODE_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get All Success`,
	getAllFail: `${ACTION_PREFIX} Get All Fail`,
};

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCallingCodes)" instead
 */
export class CallingCodeAction {
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCallingCodes)" instead
	 */
	getAll(): Action {
		return createCachedGetAction({
			type: CALLING_CODE_ACTION_TYPE.getAll,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCallingCodes)" instead
	 */
	getAllSuccess(response: CallingCodeState): ActionWithPayload {
		return createGetSuccessAction({
			type: CALLING_CODE_ACTION_TYPE.getAllSuccess,
			payload: response,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCallingCodes)" instead
	 */
	getAllFail(error: AppError | Error): ActionWithPayload {
		return {
			type: CALLING_CODE_ACTION_TYPE.getAllFail,
			payload: error,
		};
	}
}
